/**
 * Player-points tuning constants.
 *
 * Ranking is driven by total points, which are the sum of points earned from
 * buildings, ships and sciences (battle points are tracked separately on the
 * player doc). Every source converts the raw economic resources invested
 * (metal + minerals + gas) into points at the same rate.
 */
/**
 * Economic resources (metal + minerals + gas) worth a single player point.
 * Energy is deliberately excluded — it is a live production pool, not a
 * resource that is "spent" and stockpiled the way the three economic
 * resources are, so it never contributes to points.
 */
export const PLAYER_POINTS_DIVISOR = 1000;
//# sourceMappingURL=points.js.map